
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/isha-foundation/reports/view",
      function () {
        return require("private-next-pages/[region]/[language]/isha-foundation/reports/view/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/isha-foundation/reports/view"])
      });
    }
  